var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"match-home page-max-width"},[_c('MatchHeroNav'),_c('MatchNewsSection'),_c('MatchProgressSection'),_c('MatchVideoCenter'),_c('MatchFollowSection'),_c('MatchPageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }